import { persistor } from '@/store';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import Constants from '../Constants';
import { clearAuth, getAuth, getLocale, setAuth } from './IdentityService';

const http = axios.create({ baseURL: Constants.API_PATH });

const validatePageNotFound = (response: AxiosResponse) => {
    // ATENÇÃO! Toda rota dinâmica deve ser atribuída o "ID" para o replace do regex
    const requestsOk: string[] = [
        'cast/login',
        'cast/users/forgot-password',
        'cast/learning-maps/current',
        'cast/categories/ID/deactivate',
        'lms/categories/ID/activate',
    ];
    const requestWithoutParameters: string = response.config.url?.replace(/\?([\s\S]*)$/, '') || '';
    const requestUrl: string = requestWithoutParameters.replace(/\/[0-9]+/g, '/ID');

    switch (response.status) {
        case Constants.statusCode.ENTITY_NOT_FOUND:
        case Constants.statusCode.UNAUTHORIZED:
        case Constants.statusCode.PRECONDITION_FAILED:
        case Constants.statusCode.FORBIDDEN:
            return !requestsOk.includes(requestUrl);
        default:
            return false;
    }
};

http.interceptors.response.use(
    (response: AxiosResponse<{ headers: { authorization: string } }>) => {
        if (response.headers.authorization) {
            setAuth(response.headers.authorization);
        }
        return response;
    },
    (error: AxiosError) => {
        if (error.response && error.response.status === Constants.statusCode.UNAUTHORIZED) {
            if (window.location.href.indexOf('/login') === -1) {
                clearAuth();
                persistor.purge();
            }
        } else if (error.response?.status && validatePageNotFound(error.response)) {
            window.location.href = `${window.location.href.split('#')[0]}#/page-not-found`;
        }
        return Promise.reject(error);
    },
);

http.interceptors.request.use(async (requestConfig: AxiosRequestConfig) => {
    const token: string = (await getAuth()) || '';
    const locale: string = (await getLocale()) || '';
    if (token) {
        requestConfig.headers.authorization = token;

        if (!requestConfig.headers.locale) {
            requestConfig.headers.locale = locale;
        }
    }
    return requestConfig;
});

export default http;
